(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dl-postcode-checker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dl-postcode-checker')) {
  customElements.define('dl-postcode-checker', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      const input = this.querySelector('input');
      const result = this.querySelector('[role="status"]');
      const postcodes = new Set(this.dataset.postcodes.split(','));
      input.addEventListener('input', () => {
        result.textContent = '';
        delete result.dataset.status;
        input.removeAttribute('aria-invalid');
      });
      this.querySelector('form').addEventListener('submit', event => {
        event.preventDefault();
        const postcode = input.value.trim();
        const valid = /^[0-9]{4}$/.test(postcode);
        const covered = valid && postcodes.has(postcode);
        const restriction = covered && this.dataset.productRestriction;
        input.setAttribute('aria-invalid', String(!valid));
        result.dataset.status = !valid ? 'invalid' : restriction ? 'product-excluded' : covered ? 'eligible' : 'excluded';
        result.textContent = !valid ? this.dataset.invalid : covered
          ? restriction ? `${postcode}: ${restriction}` : `✓ ${postcode}: ${this.dataset.yes} ${this.dataset.soon}`
          : `${postcode}: ${this.dataset.no}`;
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
